
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { UtilisateurService } from 'src/services/utilisateur.service';

@Component({
    selector: 'app-remplacer-courriel-existant',
    templateUrl: './remplacer-courriel-existant.component.html',
    styleUrls: ['./remplacer-courriel-existant.component.scss'],
    imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule
]
})
export class RemplacerCourrielExistantComponent implements OnInit {
  ancienCourrielInput: string = '';
  nouveauCourrielInput: string = '';
  novoEntiteId: number | null = null;
  isLoading: boolean = false;
  constructor(private utilisateurService: UtilisateurService,
      private snackBar: MatSnackBar) { }

  ngOnInit() {
  }

  remplacerCourriel(){
    this.isLoading = true;

    this.utilisateurService.remplacerCourriel(this.ancienCourrielInput, this.nouveauCourrielInput).subscribe({
      next: () => {
        this.snackBar.open('Mis à jour du courriel avec succès', 'Fermer', { duration: 5000 });
        this.resetForm();
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        if(error.status === 400){
          this.snackBar.open(
            error.error?.message || ': ce mise à jour ne peut pas se faire avec l\'outil veuillez contactez l\'administrateur',
            'Fermer',
            { duration: 5000 }
          );
        }
        console.error('Erreur lors de la mise à jour:', error);
        this.isLoading = false;
      }
    });
  }

   validerEmail(email: string): boolean {
    if (!email) return false;

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

   resetForm(): void {
    this.novoEntiteId = null;
    this.ancienCourrielInput = '';
    this.nouveauCourrielInput = '';
  }

}
